module.exports = __webpack_public_path__ + "img/part-3-title.b0fe8f29.png";